import { StanModal } from '@/components';

interface ManageMembershipModalProps {
    isOpen: boolean;
    actionLabel: string;
    description: React.ReactNode;
    onConfirm: () => void;
    onClose: () => void;
    isLoading?: boolean;
}

export function ManageMembershipModal({
    isOpen,
    actionLabel,
    description,
    onConfirm,
    onClose,
    isLoading = false,
}: ManageMembershipModalProps) {
    return (
        <StanModal
            id='manage-membership-modal'
            isOpen={isOpen}
            title='Are you sure?'
            primaryActionLabel={actionLabel}
            primaryActionColor='destructive'
            primaryActionLoading={isLoading}
            secondaryActionLabel='Cancel'
            onPrimaryAction={onConfirm}
            onSecondaryAction={onClose}
            onClose={onClose}
            aria-label='Confirm membership action'
        >
            {description}
        </StanModal>
    );
}
